import { useState, type FormEvent } from 'react';
import { ApiError, Button, ErrorNote, Field, Input, useAuth } from '@mobi/web';

export function Auth() {
  const { login, signup } = useAuth();
  const [mode, setMode] = useState<'login' | 'signup'>('login');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      if (mode === 'login') await login({ email, password });
      else await signup({ name, email, phone, password, role: 'driver' });
    } catch (err) {
      setError(
        err instanceof ApiError
          ? err.message
          : err instanceof Error
            ? err.message
            : 'não foi possível entrar',
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="h-app overflow-y-auto bg-surface">
      <div className="mx-auto flex min-h-full w-full max-w-md flex-col items-center justify-center px-6 py-12">
        <div className="mb-10 flex flex-col items-center text-center">
          {/* ?v= por causa do cache immutable de um ano do Apache para .png */}
          <img src="/brand-wordmark.png?v=2" alt="WiGo" className="mb-6 h-[3.75rem] w-auto" />
          <h1 className="text-2xl font-bold tracking-tight">
            {mode === 'login' ? 'Bem-vindo de volta' : 'Criar sua conta'}
          </h1>
          <p className="mt-2 text-muted">
            {mode === 'login'
              ? 'Entre para começar a rodar.'
              : 'Depois você envia seus documentos.'}
          </p>
        </div>

        <form onSubmit={submit} className="w-full space-y-4">
          {mode === 'signup' && (
            <>
              <Field label="Nome completo">
                <Input
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  autoComplete="name"
                  required
                  minLength={3}
                  placeholder="Maria Silva"
                />
              </Field>
              <Field label="Celular" hint="com DDD">
                <Input
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  inputMode="tel"
                  autoComplete="tel"
                  required
                  placeholder="(11) 99999-9999"
                />
              </Field>
            </>
          )}

          <Field label="E-mail">
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              required
              placeholder="voce@email.com"
            />
          </Field>

          <Field label="Senha" hint={mode === 'signup' ? 'mínimo 8 caracteres' : undefined}>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete={mode === 'login' ? 'current-password' : 'new-password'}
              required
              minLength={mode === 'signup' ? 8 : undefined}
            />
          </Field>

          {error && <ErrorNote>{error}</ErrorNote>}

          <Button type="submit" size="lg" full loading={busy}>
            {mode === 'login' ? 'Entrar' : 'Criar conta'}
          </Button>
        </form>

        <button
          type="button"
          onClick={() => {
            setMode(mode === 'login' ? 'signup' : 'login');
            setError(null);
          }}
          className="mt-6 text-center text-sm text-muted underline underline-offset-4"
        >
          {mode === 'login' ? 'Não tenho conta ainda' : 'Já tenho conta'}
        </button>
      </div>
    </div>
  );
}
